import { CardViewIcon, NftsIcon, WalletIcon } from "@/domains/icons/huge-icons/monotone"

import type { CastYourVoteCardViewProps } from "./types"
import { PowerBreakdownBarView } from "./power-breakdown-bar-view"

export const CastYourVoteCardView = ({
  totalSelectedPower,
  selectedLocks,
  totalActiveLocks,
  onManageSelection,
  onRemoveLock,
}: CastYourVoteCardViewProps) => {
  return (
    <div className="overflow-hidden rounded-2xl border border-p400-light bg-p400 p-1">
      {/* Header Section */}
      <div className="flex flex-col justify-between gap-4 p-5 pb-3 sm:flex-row sm:items-center">
        <div>
          <h2 className="mb-1 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-t200">
            <WalletIcon size={12} />
            Active Power Source
          </h2>
          <div className="flex items-baseline gap-2">
            <span className="text-3xl font-black text-primary-400 drop-shadow-sm">
              {totalSelectedPower.toLocaleString(undefined, { maximumFractionDigits: 0 })}
            </span>
            <span className="text-sm font-bold text-t300">veSCALE</span>
          </div>
        </div>

        {/* The "Trigger" Button */}
        <button
          onClick={onManageSelection}
          className="flex items-center justify-center gap-2 rounded-xl bg-p200 px-4 py-2.5 text-sm font-bold text-t100 shadow-md transition-all hover:bg-primary-400 hover:shadow-primary-900/20"
        >
          <NftsIcon size={16} />
          <span>Source NFT{totalActiveLocks !== 1 ? "s" : ""}</span>
        </button>
      </div>

      {/* Power Breakdown Bar */}
      <div className="px-5 pb-5">
        {selectedLocks.length === 0 ? (
          <div className="py-1 text-sm italic text-t300">No NFTs selected. Your vote weight is 0.</div>
        ) : (
          <PowerBreakdownBarView selectedLocks={selectedLocks} totalPower={totalSelectedPower} />
        )}
      </div>
    </div>
  )
}
